import { ScrollTrigger } from '../../global/gsap';

// Called each time a new section enters the viewport (scrolling either direction).
const updateNav = (nav, sections, activeSection) => {
    const yearLinks = nav.querySelectorAll('.js-timeline-link');
    const prevButton = nav.querySelector('.js-timeline-prev');
    const nextButton = nav.querySelector('.js-timeline-next');

    const sectionArray = Array.from(sections);
    const activeIndex = sectionArray.indexOf(activeSection);
    const prevSection = sectionArray[activeIndex - 1];
    const nextSection = sectionArray[activeIndex + 1];

    // Mark the matching year dot as active, clear the rest
    yearLinks.forEach((link) => {
        link.classList.toggle('active', link.getAttribute('href') === `#${activeSection.id}`);
    });

    // Hide prev button on the first section
    if (prevSection) {
        prevButton.setAttribute('href', `#${prevSection.id}`);
        prevButton.hidden = false;
    } else {
        prevButton.hidden = true;
    }

    // Hide next on the last section
    if (nextSection) {
        nextButton.setAttribute('href', `#${nextSection.id}`);
        nextButton.hidden = false;
    } else {
        nextButton.hidden = true;
    }
};

const initEraTimeline = (nav, timeline) => {
    const sections = timeline.querySelectorAll('.js-timeline-year');

    nav.hidden = true;

    const lastSection = sections[sections.length - 1];

    // Single trigger spanning the full timeline — show nav on entry, hide outside either end
    ScrollTrigger.create({
        trigger: sections[0],
        endTrigger: lastSection,
        start: 'top center',
        end: 'bottom bottom',
        onToggle: (self) => { nav.hidden = !self.isActive; },
    });

    // Create a ScrollTrigger for each section
    sections.forEach((section) => {
        ScrollTrigger.create({
            trigger: section,
            start: 'top center',
            end: 'bottom center',
            onEnter: () => updateNav(nav, sections, section),
            onEnterBack: () => updateNav(nav, sections, section),
        });
    });
};

export { initEraTimeline as default };
